import { render, staticRenderFns } from "./PageAdministrationOverlay.vue?vue&type=template&id=57c0e1c8&scoped=true&"
import script from "./PageAdministrationOverlay.vue?vue&type=script&lang=js&"
export * from "./PageAdministrationOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c0e1c8",
  null
  
)

export default component.exports